// JS
import React from 'react';
import { randomId, useTailwindMediaQuery } from '../shared/utils';
import Slider from '../Slider';
import Button from '../Button';

// COMPONENT
const CreativeFeatureSlider = ({
  showCreativeFeatureSlider = true,
  creativeFeatureSliderOptions,
  sliderRight = true,
  data,
  gaBlockName,
  singleHero = false,
  autoplay = true,
  border = false
}) => {
  const uniqueId = randomId();
  const isMobile = useTailwindMediaQuery('md');

  return (
    <section
      id={'creative-feature-slider' + uniqueId}
      className={
        showCreativeFeatureSlider
          ? `my-24 lg:my-36 ${isMobile ? '' : 'container'}` +
            (creativeFeatureSliderOptions?.classes
              ? ' ' + creativeFeatureSliderOptions.classes
              : '')
          : 'hidden'
      }
    >
      {data && (
        <div
          className={`relative flex flex-col-reverse text-xs font-base ${
            sliderRight ? 'md:flex-row' : 'md:flex-row-reverse'
          }`}
          data-name={
            data.creative_feature_slider_title +
            ' - Creative Feature Slider Content'
          }
          data-creative={gaBlockName}
          data-id={data.contentguid}
          data-position={'banner-slot-1'}
          data-type="banner"
        >
          <div
            className={`flex flex-col ${
              border &&
              'md:border-solid md:border-y-[5px] md:border-creativeFeatureSlider'
            } h-1/2 md:h-auto w-full md:w-1/2 justify-center gap-5 p-10 lg:pl-20 xl:pl-28 ${
              sliderRight ? 'md:border-l-[5px]' : 'md:border-r-[5px]'
            }`}
          >
            <h3 className="text-sm font-base leading-tight tracking-[1.2px] uppercase m-0">
              {data.creative_feature_slider_title}
            </h3>
            <p className="relative !text-2xl !lg:text-4xl tracking-normal font-bold w-10/12 lg:w-9/12 mb-14 lg:mb-20 xl:mb-24 line-clamp-3">
              <a
                alt={data.creative_feature_slider_title}
                className="after:absolute after:inset-0 after:z-10 after:w-full after:h-full hover:text-current"
                href={data.creative_feature_slider_button_url_raw}
                data-name={
                  data.creative_feature_slider_title + ' - Body Copy link'
                }
                data-creative={gaBlockName}
                data-id={data.contentguid}
                data-position={'body-copy-link-slot-1'}
                data-type="banner-button"
              ></a>
              {data.creative_feature_slider_copy}
            </p>
            <Button
              buttonColour={'whiteSolid'}
              buttonLink={data.creative_feature_slider_button_url_raw}
              buttonLinkText={data.creative_feature_slider_button_text}
              gaBlockTitle={data.creative_feature_slider_button_text}
              gaBlockName={gaBlockName}
              gaBlockId={data.contentguid}
              buttonSlotNumber={'1'}
              buttonOptions={{
                classes: {
                  wrapper: '!justify-start'
                }
              }}
            />
          </div>
          <div className="relative w-full md:w-1/2">
            <Slider
              name="hero-swiper"
              useNavigation={!singleHero}
              usePagination={!singleHero}
              useFade={true}
              useAutoplay={autoplay}
              paginationOptions={{
                thicker: true,
                classes: {
                  wrapper:
                    'absolute right-0 left-auto bottom-0 !mt-0 mb-5 lg:mb-10 xl:mb-14 z-20'
                }
              }}
              arrowOptions={{
                creativeFeatureSlider: true
              }}
            >
              {data.creative_feature_slider_image_reference.map(
                (slide, index) => (
                  <div
                    key={index}
                    className={`relative z-0 bg-cover bg-center flex h-full items-center aspect-[9/7] ${
                      !singleHero
                        ? 'hover:cursor-grab active:cursor-grabbing'
                        : ''
                    }`}
                    style={{
                      backgroundImage: `url('${slide.creative_feature_slider_image}')`
                    }}
                    data-name={
                      data.creative_feature_slider_title +
                      ' - Banner Slide ' +
                      (index + 1)
                    }
                    data-creative={gaBlockName}
                    data-id={slide.contentguid}
                    data-position={'banner-slide-slot-' + (index + 1)}
                    data-type="banner"
                  />
                )
              )}
            </Slider>
          </div>
        </div>
      )}
    </section>
  );
};

export default CreativeFeatureSlider;
